<template>
  <div class="content-wrapper">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "ContentWrapper"
}
</script>

<style scoped>

</style>